'use strict'

module.exports = collapse

/* collapse(' \t\nbar \nbaz\t'); // ' bar baz ' */
function collapse(value) {
  return String(value).replace(/\s+/g, ' ')
}



//////////////////
// WEBPACK FOOTER
// ./~/collapse-white-space/index.js
// module id = 243
// module chunks = 35783957827783